import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { UtilityFunctions } from '../../utils/UtilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { actionCreators, State } from "../../store";
import { cookieService, userService } from '../../_services';
import { STRING_CONSTANTS } from '../../utils/constants/stringConstants';
import SuccessToast from '../../components/successToast';
import ValidationErrorToast from '../../components/validationErrorToast';
import moment from 'moment';
import { checkData } from "../../utils/checkData";
import { api } from "../../middleware/api";
import { useWhitelabel } from '../../context/WhitelabelContext';
import "../../styles/mploiBrand.css";

// Styles object
const styles = {
    container: {
        backgroundColor: '#F2F2F2',
        minHeight: '100vh',
    },
    topBar: {
        background: '#FFFFFF',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
    },
    topBarTitle: {
        color: '#0D0C0C',
        margin: 0,
        fontSize: '24px',
        fontWeight: '500',
    },
    blueBox: {
        background: '#FFFFFF',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px',
    },
    whiteText: {
        color: '#0D0C0C',
    },
    mutedText: {
        color: 'rgba(0, 0, 0, 0.6)',
    },
    input: {
        backgroundColor: '#FFFFFF',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderRadius: '4px',
        color: '#0D0C0C',
        padding: '8px 12px',
        width: '100%',
        marginBottom: '15px',
    },
    select: {
        backgroundColor: '#FFFFFF',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderRadius: '4px',
        color: '#0D0C0C',
        padding: '8px 12px',
        width: '100%',
        marginBottom: '15px',
        cursor: 'pointer',
    },
    label: {
        color: 'rgba(0, 0, 0, 0.75)',
        marginBottom: '8px',
        display: 'block',
    },
    table: {
        width: '100%',
        color: '#0D0C0C',
        borderCollapse: 'separate',
        borderSpacing: '0 8px',
    },
    tableHeader: {
        color: 'rgba(0, 0, 0, 0.6)',
        fontWeight: '500',
        padding: '15px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        textAlign: 'left',
    },
    tableCell: {
        padding: '15px',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        color: '#0D0C0C',
    },
    badge: {
        padding: '6px 12px',
        borderRadius: '4px',
        fontWeight: '500',
        display: 'inline-block',
    },
    activeBadge: {
        backgroundColor: 'rgba(40, 167, 69, 0.2)',
        color: '#28a745',
    },
    inactiveBadge: {
        backgroundColor: 'rgba(108, 117, 125, 0.2)',
        color: '#6c757d',
    },
    button: {
        padding: '8px 16px',
        borderRadius: '4px',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#0D0C0C',
    },
    primaryButton: {
        backgroundColor: '#007bff',
    },
    successButton: {
        backgroundColor: '#28a745',
    },
    dangerButton: {
        backgroundColor: 'rgba(220, 53, 69, 0.8)',
        color: '#0D0C0C',
    },
    actionButton: {
        backgroundColor: 'rgba(255, 74, 10, 0.1)',
        border: '1px solid #FF4A0A',
        color: '#FF4A0A',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        transition: 'all 0.3s ease',
        marginRight: '8px',
    },
    backButton: {
        backgroundColor: 'transparent',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        color: '#0D0C0C',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        transition: 'all 0.2s ease',
    },
    createButton: {
        backgroundColor: '#FF4A0A',
        color: '#0D0C0C',
        padding: '10px 20px',
        borderRadius: '4px',
        border: 'none',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(13, 12, 12, 0.45)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modalContent: {
        backgroundColor: '#F2F2F2',
        border: '1px solid rgba(255, 74, 10, 0.3)',
        borderRadius: '8px',
        padding: '24px',
        width: '90%',
        maxWidth: '500px',
        maxHeight: '90vh',
        overflow: 'auto',
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        paddingBottom: '10px',
    },
    modalTitle: {
        color: '#0D0C0C',
        margin: 0,
        fontSize: '20px',
    },
    closeButton: {
        backgroundColor: 'transparent',
        border: 'none',
        color: 'rgba(0, 0, 0, 0.6)',
        fontSize: '24px',
        cursor: 'pointer',
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px',
        marginTop: '20px',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        paddingTop: '20px',
    },
    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        color: '#0D0C0C',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    submitButton: {
        backgroundColor: '#FF4A0A',
        color: '#0D0C0C',
        padding: '8px 16px',
        borderRadius: '4px',
        border: 'none',
        fontWeight: '600',
        cursor: 'pointer',
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        textAlign: 'center',
    },
    emptyStateIcon: {
        fontSize: '48px',
        color: 'rgba(0, 0, 0, 0.6)',
        marginBottom: '16px',
    },
    emptyStateText: {
        color: 'rgba(0, 0, 0, 0.6)',
        fontSize: '18px',
        marginBottom: '24px',
    },
    loadingOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(242, 242, 242, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    loadingSpinner: {
        color: '#FF4A0A',
        fontSize: '24px',
    },
    confirmationModal: {
        backgroundColor: '#F2F2F2',
        border: '1px solid rgba(220, 53, 69, 0.3)',
        borderRadius: '8px',
        padding: '24px',
        width: '90%',
        maxWidth: '400px',
    },
    confirmationText: {
        color: '#0D0C0C',
        fontSize: '16px',
        marginBottom: '20px',
        textAlign: 'center',
    },
    confirmationButtons: {
        display: 'flex',
        justifyContent: 'center',
        gap: '16px',
    },
};

// Industry options for demo accounts
const INDUSTRY_OPTIONS = [
    { id: 'retail', name: 'Retail' },
    { id: 'manufacturing', name: 'Manufacturing' },
    { id: 'healthcare', name: 'Healthcare' },
    { id: 'technology', name: 'Technology' },
    { id: 'finance', name: 'Finance & Banking' },
    { id: 'education', name: 'Education' },
    { id: 'hospitality', name: 'Hospitality' },
    { id: 'construction', name: 'Construction' },
    { id: 'professional_services', name: 'Professional Services' },
    { id: 'other', name: 'Other' },
];

const ARDemoAccounts = (props) => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const [userData, setUserData] = useState(null);
    const { setUnreadNotificationCount } = bindActionCreators(actionCreators, dispatch);
    
    // Whitelabel branding
    const whitelabel = useWhitelabel();
    const productName = whitelabel?.productName || 'MPLOI Invoice Chaser';
    const brandName = whitelabel?.brandName || 'MPLOI';
    const wlLogoSrc = whitelabel?.logoSrc;
    const [showGuestAccessPrompt, setShowGuestAccessPrompt] = useState(false);
    const [unreadMsgCount, setUnreadMsgCount] = useState(0);
    const user = cookieService?.getCookie(STRING_CONSTANTS?.cookieStrings?.user);
    const isUserLoggedIn = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.token);
    
    // Demo accounts data
    const [demoAccounts, setDemoAccounts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState(null);
    
    // Form data for creating new demo account
    const [formData, setFormData] = useState({
        companyName: '',
        industry: 'retail',
        businessContext: '', // NEW: For the business/invoice description
    });

    const { resetState, closeOnlineOfflineSocket } = bindActionCreators(
      actionCreators,
      dispatch
    );
    
    const handleLogout = (e) => {
      e.preventDefault();
      closeOnlineOfflineSocket(true);
      userService
        .logout()
        .then((res) => {
          api
            .deleteApi("device-token/", {
              deviceType: "WEB",
              token: `${cookieService.getCookie("fcm")}`,
            })
            .then((res) => {
              cookieService.removeAllCookies();
              props.history.push(STRING_CONSTANTS.navigationString.login);
              resetState();
            })
            .catch((e) => {
              cookieService.removeAllCookies();
              props.history.push(STRING_CONSTANTS.navigationString.login);
              resetState();
            });
        })
        .catch((err) => {
          checkData(props, "/", err);
        });
    };

    // Fetch demo accounts from API
    const fetchDemoAccounts = async () => {
        setIsLoading(true);
        try {
            // Get user data first
            const userData = await userService.getUserData();
            cookieService.saveCookie(STRING_CONSTANTS.cookieStrings.user, userData);
            setUnreadNotificationCount(userData?.user?.unreadNotificationCount);
            setUserData(userData);
            
            // Get demo accounts data
            const demoAccountsResponse = await userService.aiRequest({
                method: 'get-demo-accounts',
                data: {'affiliate_email': userData?.user?.email}
            });
            
            if (demoAccountsResponse && demoAccountsResponse.data) {
                console.log("Demo accounts data:", demoAccountsResponse.data);
                setDemoAccounts(demoAccountsResponse.data.demoAccounts || []);
            }

        } catch (error) {
            console.error("Error fetching demo accounts:", error);
            // If API fails, use empty data
            setDemoAccounts([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isUserLoggedIn) {
            fetchDemoAccounts();
        }
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateForm = () => {
        if (!formData.companyName.trim()) {
            ValidationErrorToast("Error", "Company name is required");
            return false;
        }
        return true;
    };

    const handleCreateAccount = async () => {
        if (!validateForm()) return;
        
        setIsLoading(true);
        try {
            const response = await userService.aiRequest({
                method: 'create-demo-account',
                data: {
                    affiliate_email: userData?.user?.email,
                    companyName: formData.companyName,
                    industry: formData.industry,
                    businessContext: formData.businessContext,
                }
            });
            
            if (response && response.data) {
                SuccessToast("Success", "Demo account created successfully");
                setShowCreateModal(false);
                setFormData({
                    companyName: '',
                    industry: 'retail',
                    businessContext: '',
                });
                fetchDemoAccounts();
            }
        } catch (error) {
            console.error("Error creating demo account:", error);
            ValidationErrorToast("Error", "Failed to create demo account");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDeleteAccount = async () => {
        if (!selectedAccount) return;
        
        setIsLoading(true);
        try {
            const response = await userService.aiRequest({
                method: 'delete-demo-account',
                data: {
                    accountId: selectedAccount.id,
                    organizationId: selectedAccount.organizationId,
                }
            });
            
            if (response) {
                SuccessToast("Success", "Demo account deleted successfully");
                setShowDeleteModal(false);
                setSelectedAccount(null);
                fetchDemoAccounts();
            }
        } catch (error) {
            console.error("Error deleting demo account:", error);
            ValidationErrorToast("Error", "Failed to delete demo account");
        } finally {
            setIsLoading(false);
        }
    };


    const handleLoginToAccount = (account) => {
        // Construct the URL for the AR Dashboard with the demo_org_id parameter
        // Ensure the base path '/ar/dashboard' is correct for your routing setup
        const demoDashboardUrl = `/ar/?demo_org_id=${account.organizationId}`;
        
        // Open the URL in a new window/tab
        window.open(demoDashboardUrl, '_blank');
        
        // You can still show a toast if you like, or remove it
        // SuccessToast("Redirecting", `Opening demo for ${account.organizationName}...`);
    };

    return (
        <section className="main-dashboard-wrap mploiBrand" style={styles.container}>
            <Helmet>
                <title>{brandName}: Demo Accounts Management</title>
            </Helmet>
            
            {/* Loading Overlay */}
            {isLoading && (
                <div style={styles.loadingOverlay}>
                    <div style={styles.loadingSpinner}>
                        Loading...
                    </div>
                </div>
            )}
                        
            {/* Create Demo Account Modal */}
            {showCreateModal && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modalContent}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>Create Demo Account</h3>
                            <button 
                                style={styles.closeButton}
                                onClick={() => setShowCreateModal(false)}
                            >
                                ×
                            </button>
                        </div>
                        
                        <div> {/* Form content starts here */}
                            <div style={{marginBottom: '15px'}}>
                                <label htmlFor="companyName" style={styles.label}>Company Name *</label>
                                <input 
                                    type="text"
                                    id="companyName"
                                    name="companyName"
                                    style={styles.input}
                                    value={formData.companyName}
                                    onChange={handleInputChange}
                                    placeholder="Enter company name"
                                />
                            </div>
                            
                            <div style={{marginBottom: '15px'}}>
                                <label htmlFor="industry" style={styles.label}>Industry *</label>
                                <select
                                    id="industry"
                                    name="industry"
                                    style={styles.select} // This styles the main select box
                                    value={formData.industry}
                                    onChange={handleInputChange}
                                >
                                    {INDUSTRY_OPTIONS.map(industry => (
                                        <option 
                                            key={industry.id} 
                                            value={industry.id}
                                            // Here's our little style addition, darling!
                                            style={{ 
                                                backgroundColor: styles.container.backgroundColor,
                                                color: styles.whiteText.color // Ensuring white text #ffffff
                                            }}
                                        >
                                            {industry.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* AI-Powered Setup Options - Revised */}
                            <div style={{
                                marginTop: '25px',
                                marginBottom: '15px',
                                borderTop: '1px solid rgba(0, 0, 0, 0.1)',
                                paddingTop: '20px'
                            }}>
                                <h4 style={{...styles.whiteText, fontSize: '16px', marginBottom: '15px'}}>
                                    AI-Powered Data Generation
                                </h4>
                                
                                {/* "Generate realistic invoice data" - Now implicit with description and textarea */}
                                <div style={{
                                    marginBottom: '20px',
                                    padding: '12px',
                                    backgroundColor: 'rgba(255, 74, 10, 0.1)',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(255, 74, 10, 0.2)'
                                }}>
                                    <div>
                                        <label style={{...styles.whiteText, fontWeight: '500', display: 'block', marginBottom: '5px'}}>
                                            Realistic Invoice Data Generation
                                        </label>
                                        <p style={{...styles.mutedText, margin: '0 0 15px 0', fontSize: '13px'}}>
                                            Our AI will generate realistic customer profiles, invoices, and payment histories. 
                                            To help us tailor this data, please tell us a bit about the business and its typical outstanding invoices.
                                        </p>
                                        <label htmlFor="businessContext" style={{...styles.label, fontSize: '13px', color: 'rgba(0, 0, 0, 0.65)'}}>
                                            Describe the business & typical overdue invoices (optional):
                                        </label>
                                        <textarea
                                            id="businessContext"
                                            name="businessContext"
                                            rows={4}
                                            style={{...styles.input, height: 'auto', paddingTop: '10px', paddingBottom: '10px'}}
                                            value={formData.businessContext}
                                            onChange={handleInputChange}
                                            placeholder="e.g., We are a SaaS company providing project management tools. Our overdue invoices are typically from small to medium-sized businesses, ranging from $500 to $5000, often 30-60 days past due."
                                        />
                                    </div>
                                </div>
                                {/* "Use AI to configure optimal settings" option is now REMOVED */}
                            </div>
                        </div> {/* Form content ends here */}
                        
                        <div style={styles.modalFooter}>
                            <button 
                                style={styles.cancelButton}
                                onClick={() => setShowCreateModal(false)}
                            >
                                Cancel
                            </button>
                            <button 
                                style={styles.submitButton}
                                onClick={handleCreateAccount}
                            >
                                Create Account
                            </button>
                        </div>
                    </div>
                </div>
            )}
            
            {/* Delete Confirmation Modal */}
            {showDeleteModal && selectedAccount && (
                <div style={styles.modalOverlay}>
                    <div style={styles.confirmationModal}>
                        <h3 style={{...styles.whiteText, textAlign: 'center', marginBottom: '20px'}}>
                            Confirm Deletion
                        </h3>
                        <p style={styles.confirmationText}>
                            Are you sure you want to delete the demo account for <strong>{selectedAccount.organizationName}</strong>? This action cannot be undone.
                        </p>
                        <div style={styles.confirmationButtons}>
                            <button 
                                style={styles.cancelButton}
                                onClick={() => setShowDeleteModal(false)}
                            >
                                Cancel
                            </button>
                            <button 
                                style={styles.dangerButton}
                                onClick={handleDeleteAccount}
                            >
                                Delete Account
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div id="wrapper" style={{ height: "100vh" }}>
                {/* Sidebar */}
                <ul className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion ${state.common.showSidebarOnMobileView ? "active" : ""}`} id="accordionSidebar">
                    <div>
                        <Link style={{ pointerEvents: "none" }} className="sidebar-brand d-flex align-items-center justify-content-center" to="#">
                            <img src={wlLogoSrc || (UtilityFunctions.getImageURL() + "db-logo.svg")} alt="Logo" />
                        </Link>
                        {!user?.user?.isAccountsSignup && <li className="nav-item">
                            <Link className="nav-link" to="/ar/affiliate/dashboard">
                                <img src={UtilityFunctions.getImageURL() + "home-icon-blank-white.svg"} alt="" />
                                <img src={UtilityFunctions.getImageURL() + "home-icon-fill-green.svg"} alt="" />
                            </Link>
                        </li>}
                    </div>

                    <div>
                        <li className='d-grid justify-content-center gap-2 text-white'>
                            <span style={{ cursor: "pointer" }}
                                onClick={handleLogout}
                            >
                                Logout
                            </span>
                        </li>
                    </div>
                </ul>

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            {/* Back Button */}
                            <div style={{marginBottom: '24px', marginTop: '12px'}}>
                                <button 
                                    style={styles.backButton}
                                    onClick={() => props.history.push('/ar/affiliate/dashboard')}
                                >
                                    <span style={{fontSize: '18px', lineHeight: '1'}}>←</span> 
                                    <span>Back to Affiliate Dashboard</span>
                                </button>
                            </div>

                            {/* Top Bar with Demo Account Information */}
                            <div style={{
                                background: '#FFFFFF',
                                padding: '24px',
                                borderRadius: '12px',
                                marginBottom: '24px',
                                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                                border: '1px solid rgba(255, 74, 10, 0.2)',
                            }}>
                                <div className="row align-items-center">
                                    <div className="col-lg-8">
                                        <h1 style={{...styles.whiteText, fontSize: '28px', marginBottom: '12px', fontWeight: '600'}}>
                                            Demo Account Management
                                        </h1>
                                        <p style={{...styles.whiteText, opacity: '0.8', fontSize: '16px', lineHeight: '1.6'}}>
                                            Create and manage demo accounts for potential customers. Demo accounts allow prospects to experience 
                                            {productName} with sample data before committing to a subscription.
                                        </p>
                                        
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginTop: '16px',
                                            background: 'rgba(255, 74, 10, 0.1)',
                                            padding: '12px 16px',
                                            borderRadius: '8px',
                                            border: '1px solid rgba(255, 74, 10, 0.3)'
                                        }}>
                                            <div style={{marginRight: '12px'}}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11 7H13V13H11V7ZM11 15H13V17H11V15Z" fill="#FF4A0A"/>
                                                </svg>
                                            </div>
                                            <p style={{...styles.whiteText, margin: 0, fontSize: '14px'}}>
                                                Each demo account includes sample invoices, customers, and payment history. 
                                                Demo accounts are active for 14 days.
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div className="col-lg-4">
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '100%'
                                        }}>
                                            <button 
                                                style={styles.createButton}
                                                onClick={() => setShowCreateModal(true)}
                                            >
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM12 8.8H8.8V12H7.2V8.8H4V7.2H7.2V4H8.8V7.2H12V8.8Z" fill="#F2F2F2"/>
                                                </svg>
                                                Create Demo Account
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Demo Accounts Table */}
                            <div style={styles.blueBox}>
                                <h3 style={{...styles.whiteText, marginBottom: '20px'}}>
                                    Your Demo Accounts
                                </h3>
                                
                                {!isLoading && demoAccounts.length === 0 ? (
                                    <div style={styles.emptyState}>
                                        <div style={styles.emptyStateIcon}>
                                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20 6H16V4C16 2.9 15.1 2 14 2H10C8.9 2 8 2.9 8 4V6H4C2.9 6 2 6.9 2 8V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V8C22 6.9 21.1 6 20 6ZM10 4H14V6H10V4ZM20 19H4V8H20V19Z" fill="rgba(0, 0, 0, 0.12)"/>
                                                <path d="M13 14H11V17H8V14H6V12H8V9H11V12H13V14Z" fill="rgba(0, 0, 0, 0.12)"/>
                                            </svg>
                                        </div>
                                        <p style={styles.emptyStateText}>
                                            You haven't created any demo accounts yet
                                        </p>
                                        <button 
                                            style={styles.createButton}
                                            onClick={() => setShowCreateModal(true)}
                                        >
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM12 8.8H8.8V12H7.2V8.8H4V7.2H7.2V4H8.8V7.2H12V8.8Z" fill="#F2F2F2"/>
                                            </svg>
                                            Create Your First Demo Account
                                        </button>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table style={styles.table}>
                                            <thead>
                                                <tr>
                                                    <th style={styles.tableHeader}>Company</th>
                                                    <th style={styles.tableHeader}>Created</th>
                                                    <th style={styles.tableHeader}>Expires</th>
                                                    <th style={styles.tableHeader}>Status</th>
                                                    <th style={styles.tableHeader}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {demoAccounts.map(account => (
                                                    <tr key={account.id}>
                                                        <td style={styles.tableCell}>
                                                            <div style={{fontWeight: '500'}}>{account.organizationName}</div>
                                                        </td>
                                                        <td style={styles.tableCell}>
                                                            {moment(account.createdAt).format('DD/MM/YYYY')}
                                                        </td>
                                                        <td style={styles.tableCell}>
                                                            {moment(account.expiresAt).format('DD/MM/YYYY')}
                                                        </td>
                                                        <td style={styles.tableCell}>
                                                            <span style={{
                                                                ...styles.badge,
                                                                ...(account.status === 'active' ? styles.activeBadge : styles.inactiveBadge)
                                                            }}>
                                                                {account.status === 'active' ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </td>
                                                        <td style={styles.tableCell}>
                                                            <div style={{display: 'flex'}}>
                                                                <button 
                                                                    style={styles.actionButton}
                                                                    onClick={() => handleLoginToAccount(account)}
                                                                >
                                                                    Login
                                                                </button>
                                                                <button 
                                                                    style={{
                                                                        ...styles.actionButton,
                                                                        backgroundColor: 'rgba(220, 53, 69, 0.1)',
                                                                        borderColor: '#dc3545',
                                                                        color: '#dc3545'
                                                                    }}
                                                                    onClick={() => {
                                                                        setSelectedAccount(account);
                                                                        setShowDeleteModal(true);
                                                                    }}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            {/* Information Box */}
                            <div style={{
                                backgroundColor: 'rgba(0, 123, 255, 0.1)',
                                border: '1px solid rgba(0, 123, 255, 0.3)',
                                borderRadius: '8px',
                                padding: '20px',
                                marginBottom: '20px',
                            }}>
                                <h3 style={{
                                    color: '#0D0C0C',
                                    fontSize: '18px',
                                    marginBottom: '15px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11 7H13V13H11V7ZM11 15H13V17H11V15Z" fill="#FF4A0A"/>
                                    </svg>
                                    About Demo Accounts
                                </h3>
                                
                                <div style={{
                                    display: 'flex',
                                    marginBottom: '10px',
                                }}>
                                    <span style={{
                                        color: '#FF4A0A',
                                        marginRight: '10px',
                                        fontSize: '16px',
                                    }}>✓</span>
                                    <p style={{
                                        color: 'rgba(0, 0, 0, 0.75)',
                                    }}>
                                        <strong>Purpose:</strong> Demo accounts allow potential customers to experience {productName} with realistic sample data.
                                    </p>
                                </div>
                                
                                <div style={{
                                    display: 'flex',
                                    marginBottom: '10px',
                                }}>
                                    <span style={{
                                        color: '#FF4A0A',
                                        marginRight: '10px',
                                        fontSize: '16px',
                                    }}>✓</span>
                                    <p style={{
                                        color: 'rgba(0, 0, 0, 0.75)',
                                    }}>
                                        <strong>Sample Data:</strong> Each demo account is pre-populated with sample invoices, customers, and payment history.
                                    </p>
                                </div>
                                
                                <div style={{
                                    display: 'flex',
                                    marginBottom: '10px',
                                }}>
                                    <span style={{
                                        color: '#FF4A0A',
                                        marginRight: '10px',
                                        fontSize: '16px',
                                    }}>✓</span>
                                    <p style={{
                                        color: 'rgba(0, 0, 0, 0.75)',
                                    }}>
                                        <strong>Duration:</strong> Demo accounts are active for 14 days by default.
                                    </p>
                                </div>
                                
                                <div style={{
                                    display: 'flex',
                                    marginBottom: '10px',
                                }}>
                                    <span style={{
                                        color: '#FF4A0A',
                                        marginRight: '10px',
                                        fontSize: '16px',
                                    }}>✓</span>
                                    <p style={{
                                        color: 'rgba(0, 0, 0, 0.75)',
                                    }}>
                                        <strong>Login Access:</strong> You can log in to any demo account to check its status or demonstrate features to prospects.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ARDemoAccounts;